export default __webpack_public_path__ + "static/media/Linkedin.92392e66.png";